import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface AlertMessage {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

interface FormAlertProps {
  alertMessage: AlertMessage | null;
  onClose: () => void;
  autoHideDuration?: number;
}

const FormAlert: React.FC<FormAlertProps> = ({
  alertMessage,
  onClose,
  autoHideDuration = 6000
}) => {
  return (
    <Snackbar 
      open={!!alertMessage} 
      autoHideDuration={autoHideDuration} 
      onClose={onClose}
    >
      <Alert 
        onClose={onClose} 
        severity={alertMessage?.type || 'info'} 
        sx={{ width: '100%' }}
      >
        {alertMessage?.message}
      </Alert>
    </Snackbar>
  );
};

export default FormAlert; 